import { ChangeDetectionStrategy, Component, inject, signal } from '@angular/core';

import { IconComponent } from '@/design-system/atoms/icon/icon.component';
import { NavItemComponent } from '@/design-system/molecules/nav-item/nav-item.component';
import { UserCardComponent } from '@/design-system/organisms/user-card/user-card.component';
import { Router, RouterLink, RouterLinkActive } from '@angular/router';
import { TranslocoPipe } from '@jsverse/transloco';
import { AUTH_ROUTES, type NavRouteData } from '@/routes/app.routes';
import { APP_URLS } from '@/routes/app.paths';
import { IconButtonComponent } from '@/design-system/molecules/icon-button/icon-button.component';
import { AuthStore } from '@/features/auth-store.service';

@Component({
  selector: 'app-sidebar',
  imports: [
    IconComponent,
    IconButtonComponent,
    NavItemComponent,
    UserCardComponent,
    RouterLink,
    RouterLinkActive,
    TranslocoPipe,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrl: './sidebar.component.scss',
  templateUrl: './sidebar.component.html',
})
export class SidebarComponent {
  private authStore = inject(AuthStore);
  private router = inject(Router);
  protected collapsed = signal(false);
  protected user = this.authStore.currentUser;

  protected toggleCollapse(): void {
    this.collapsed.update((v) => !v);
  }

  // TODO: replace with popover on usercard once the design is available
  protected logout(): void {
    this.authStore.logout();
    void this.router.navigateByUrl(APP_URLS.login);
  }

  protected readonly navItems = AUTH_ROUTES.filter((r) => Boolean(r.data?.['nav'])).map((r) => {
    const data = r.data as NavRouteData;
    return { path: r.path, label: data.label, icon: data.icon };
  });
}
